import { Component, OnInit } from '@angular/core';

import { NameIndex, NameValue, WidgetConfiguration } from '../../../interfaces/WidgetInterfaces';
import { WidgetGroup, WidgetRegistration } from '../../../interfaces/UserInterfaces';
import { UtilityFunctions } from '../../../classes/UtilityFunctions';
import { WebPlatformApiService } from '../../../services/WebPlatformApiService';
import { DisplayStateService } from '../../../services/DisplayStateService';

@Component({
  selector: 'app-widget-registration',
  template: `<div class="container-fluid">
  <div class="row">
    <div class="col-sm-6">
      <!--Start of success 'Available' section  -->
      <section class="card card-outline-success">
        <div class="card-block">
          <h4 class="card-title">Available</h4>
        </div>
        <ul class="list-group list-group-flush">
          <li class="list-group-item justify-content-between" *ngFor="let widget of AvailableWidgets()">
            {{widget.name}}
            <div>
              Group:


              <button *ngFor="let group of GroupWidgetsToDisplay(); let i = index" [disabled]="WidgetIsInGroup(widget.name, group)" type="button"
                class="btn btn-sm btn-outline-primary" (click)="AddToGroup(widget, group)">{{i+1}}</button>

              <button type="button" class="btn btn-sm btn-outline-primary" (click)="AddToNewGroup(widget)">New</button>

              <button [disabled]="!WidgetIsGrouped(widget.name)" type="button" class="btn btn-sm btn-outline-primary" (click)="AddToUngrouped(widget)">None</button>
              <button (click)="AddToHidden(widget)" type="button" class="btn btn-sm btn-secondary">Hide</button>
            </div>

          </li>
        </ul>
      </section>
      <!--End of success 'Available' section  -->
      <!--End of danger 'Excluded' section  -->
      <section class="card card-outline-danger margin-top-10">
        <div class="card-block">
          <h4 class="card-title">Excluded</h4>
        </div>
        <ul class="list-group list-group-flush">
          <li class="list-group-item justify-content-between" *ngFor="let widget of UnavailableWidgets()">
            {{widget.name}}
            <div class="float-sm-right">
              <button *ngFor="let group of GroupWidgetsToDisplay(); let i = index" type="button" class="btn btn-sm btn-secondary" (click)="AddToGroup(widget, group)">Group {{i+1}}</button>

              <button type="button" class="btn btn-sm btn-secondary" (click)="AddToNewGroup(widget)">New Group</button>

              <button type="button" class="btn btn-sm btn-secondary" (click)="AddToUngrouped(widget)">No Group</button>
            </div>
          </li>
        </ul>
      </section>
      <!--End of danger 'Excluded' section  -->
    </div>
    <!--End of .col-sm-6 div  -->

    <div *ngIf="widgetRegistrationCopy" class="col-sm-6">

      <section id="accordion" role="tablist" aria-multiselectable="true">
        <div *ngFor="let group of GroupWidgetsToDisplay(); let i = index" [ngClass]="i > 0 ? 'card margin-top-10 card-outline-primary' : 'card card-outline-primary'">
          <div class="card-header" role="tab" id="heading{{ i + 1 }}">
            <h5 class="mb-0">
              <a data-toggle="collapse" data-parent="#accordion" href="#collapse{{i+1}}" aria-expanded="true">
                {{group.contextKey}} group {{group.index}}
              </a>
              <i class="fa fa-caret-down" aria-hidden="true"></i>
              <div class="float-sm-right">
                <button [disabled]="!CanGroupUp(group)" type="button" class="btn btn-sm btn-secondary" (click)="GroupUp(group)"><i class="fa fa-arrow-up"></i></button>
                <button [disabled]="!CanGroupDown(group)" type="button" class="btn btn-sm btn-secondary" (click)="GroupDown(group)"><i class="fa fa-arrow-down"></i></button>
              </div>
            </h5>
          </div>

          <div id="collapse{{ i + 1 }}" class="collapse show" role="tabpanel">
            <div class="card-block remove-card-block-padding">
              <ul class="list-group list-group-flush">
                <li class="list-group-item justify-content-between" *ngFor="let widget of WidgetNameIndexesFor(group)">{{widget.name}} ({{widget.index}})
                  <div>
                    <button [disabled]="!CanWidgetUp(group, widget)" type="button" class="btn btn-sm btn-secondary" (click)="WidgetUp(group, widget)"><i class="fa fa-arrow-up fa-2"></i></button>
                    <button [disabled]="!CanWidgetDown(group, widget)" type="button" class="btn btn-sm btn-secondary" (click)="WidgetDown(group, widget)"><i class="fa fa-arrow-down fa-2"></i></button>
                  </div>
              </ul>
            </div>
            <div class="card-block remove-card-block-padding">
              <div class="card">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item justify-content-between">
                    <h2 class="badge badge-primary">Height</h2>
                    <div class="btn-group" role="group">
                      <button *ngFor="let hs of heightSpecValues" [disabled]="group.heightSpec === hs.value" (click)="GroupHeightChange(group, hs.value)"
                        type="button" class="btn btn-secondary btn-sm">{{hs.name}}</button>
                    </div>
                  </li>
                  <li class="list-group-item justify-content-between">
                    <h2 class="badge badge-primary">Width</h2>
                    <div class="btn-group" role="group">
                      <button *ngFor="let ws of widthSpecValues" [disabled]="group.widthSpec === ws.value" (click)="GroupWidthChange(group, ws.value)"
                        type="button" class="btn btn-secondary btn-sm">{{ws.name}}</button>
                    </div>
                  </li>
                  <li class="list-group-item list-group-item-action list-group-item-danger">
                    <button (click)="ClearGroup(group)" type="button" class="btn btn-secondary btn-sm">Remove Group</button>
                  </li>
                </ul>
              </div>
              <!--End of .card div  -->
            </div>
          </div>
        </div>
      </section>
      <!--End of primary section  -->
    </div>
    <!--End of .col-sm-6 div  -->

  </div>
  <div class="row">
    <div class="col-sm-12">
      <div class="btn-group" role="group" aria-label="Basic example">
        <button *ngIf="preferredSettingsCount" (click)="UsePreferred()" type="button" class="btn btn-secondary">Use Preferred Settings</button>
        <button type="button" (click)="SavePreferred()" class="btn btn-secondary">Save as Preferred Settings</button>
        <button type="button" (click)="ClearAllSelections()" class="btn btn-secondary">Reset Layout</button>
      </div>
    </div>
  </div>
  <!--End of main .row div  -->
</div>
<!-- End of .container-fluid div -->`,
  styles: [`.margin-top-10{
    margin-top:10px;
}

.remove-card-block-padding{
    padding:0;
}

a{
    color:inherit;
}
a:focus, a:hover{
    text-decoration:none;
}`]
})
export class WidgetRegistrationComponent implements OnInit {

  heightSpecValues: NameValue[] = [
    { name: 'short', value: '1' },
    { name: 'medium', value: '2' },
    { name: 'tall', value: '3' },
    { name: 'auto', value: '*' }];

   widthSpecValues: NameValue[] = [
    { name: '1/4', value: '1' },
    { name: '1/3', value: '2' },
    { name: '1/2', value: '3' },
    { name: '2/3', value: '4' },
    { name: 'full', value: '5' }];

  // current matching widgets regardless of what the user does
  matchingWidgetsSource: WidgetConfiguration[];

  // matching widgets state while user is making changes
  matchingWidgets: WidgetConfiguration[];

  contextKey = '';

  // Copy of current widget registration that user can change without
  // affecting anything else
  widgetRegistrationCopy: WidgetRegistration;
  preferredSettingsCount = 0;
  constructor(private displayStateService: DisplayStateService, private webPlatformApiService: WebPlatformApiService) { }

  Initialize(matchingWidgets: WidgetConfiguration[]) {
    this.matchingWidgetsSource = matchingWidgets;
    this.matchingWidgets = matchingWidgets;
    this.Reset();
  }

  CreateContextKey() {
    if (this.matchingWidgets) {
      this.contextKey =
        UtilityFunctions.CreateContextKey(this.matchingWidgets,
        this.displayStateService.appState.current.context);
    }
  }

  ClearAllSelections() {
     if (this.widgetRegistrationCopy && this.widgetRegistrationCopy.groupedWidgets) {

      this.widgetRegistrationCopy.groupedWidgets =
        this.widgetRegistrationCopy.groupedWidgets.filter(g => g.contextKey !== this.contextKey);
    }
  }

  Reset() {
    this.CreateContextKey();
    this.preferredSettingsCount = this.displayStateService.GetPreferredSettings(this.contextKey).length;
    this.matchingWidgetsSource = this.matchingWidgets;

    if (this.displayStateService.appState.current.userStatistics === undefined ||
      this.displayStateService.appState.current.userStatistics.widgetRegistration === undefined) {
      this.widgetRegistrationCopy = undefined;
      return;
    }
    this.widgetRegCopyLocal();
  }

  private widgetRegCopyLocal() {
    this.widgetRegistrationCopy = { excludedWidgets: [], groupedWidgets: [] };
    // copy grouped widgets
    if (this.displayStateService.appState.current.userStatistics.widgetRegistration.groupedWidgets !== undefined) {
      this.widgetRegistrationCopy.groupedWidgets = [];
      this.displayStateService.appState.current.userStatistics.widgetRegistration.groupedWidgets.forEach(gw => {
        this.widgetRegistrationCopy.groupedWidgets.push(
          { index: gw.index, widgets: [], heightSpec: gw.heightSpec, widthSpec: gw.widthSpec, contextKey: gw.contextKey, hidden: gw.hidden }
        );
        gw.widgets.forEach(w => {
          this.widgetRegistrationCopy.groupedWidgets[this.widgetRegistrationCopy.groupedWidgets.length - 1]
            .widgets.push({ index: w.index, name: w.name });
        });
      });
    }

    // Normalize order/indexes
    this.NormalizeIndexes();
  }

  GroupHeightChange(group: WidgetGroup, newValue: string) {
    group.heightSpec = newValue;
  }

  GroupWidthChange(group: WidgetGroup, newValue: string) {
    group.widthSpec = newValue;
  }

  ContextMatchedGroups(): WidgetGroup[] {

    if (this.widgetRegistrationCopy && this.widgetRegistrationCopy.groupedWidgets) {
      return this.widgetRegistrationCopy.groupedWidgets.filter(g => g.contextKey === this.contextKey);
    } else {
      return [];
    }

  }

  GroupWidgetsToDisplay(): WidgetGroup[] {
    if (this.widgetRegistrationCopy === undefined || this.widgetRegistrationCopy.groupedWidgets === undefined) {
      return [];
    } else {
      return this.ContextMatchedGroups()
        .filter(gw => !gw.hidden &&  this.WidgetsFor(gw).length > 0);
    }
  }

  CanGroupUp(widgetGroup: WidgetGroup): boolean {
    return this.GroupWidgetsToDisplay().findIndex(x => x.index === widgetGroup.index) > 0;
  }
  GroupUp(widgetGroup: WidgetGroup) {
    const positionIndex = this.GroupWidgetsToDisplay().findIndex(x => x.index === widgetGroup.index);
    if (positionIndex > 0) {
      const newIndex = this.GroupWidgetsToDisplay()[positionIndex - 1].index;
      this.GroupWidgetsToDisplay()[positionIndex - 1].index = widgetGroup.index;
      widgetGroup.index = newIndex;
      this.NormalizeIndexes();
    }
  }

  CanGroupDown(widgetGroup: WidgetGroup): boolean {
    return this.GroupWidgetsToDisplay().findIndex(x => x.index === widgetGroup.index) < this.GroupWidgetsToDisplay().length - 1;
  }

  GroupDown(widgetGroup: WidgetGroup) {
    const positionIndex = this.GroupWidgetsToDisplay().findIndex(x => x.index === widgetGroup.index);
    if (positionIndex < this.GroupWidgetsToDisplay().length - 1) {
      const newIndex = this.GroupWidgetsToDisplay()[positionIndex + 1].index;
      this.GroupWidgetsToDisplay()[positionIndex + 1].index = widgetGroup.index;
      widgetGroup.index = newIndex;
      this.NormalizeIndexes();
    }
  }

  CanWidgetUp(group: WidgetGroup, widgetNI: NameIndex): boolean {
    return group.widgets.findIndex(ni => ni.name === widgetNI.name) > 0;
  }

  WidgetUp(group: WidgetGroup, widgetNI: NameIndex) {
    const positionIndex = group.widgets.findIndex(ni => ni.name === widgetNI.name);
    if (positionIndex > 0) {
      const newIndex = group.widgets[positionIndex - 1].index;
      group.widgets[positionIndex - 1].index = group.widgets[positionIndex].index;
      group.widgets[positionIndex].index = newIndex;
      this.NormalizeIndexes();
    }

  }

  CanWidgetDown(group: WidgetGroup, widgetNI: NameIndex): boolean {
    return group.widgets.findIndex(ni => ni.name === widgetNI.name) < group.widgets.length - 1;
  }

  WidgetDown(group: WidgetGroup, widgetNI: NameIndex) {
    const positionIndex = group.widgets.findIndex(ni => ni.name === widgetNI.name);
    if (positionIndex < group.widgets.length - 1) {
      const newIndex = group.widgets[positionIndex + 1].index;
      group.widgets[positionIndex + 1].index = group.widgets[positionIndex].index;
      group.widgets[positionIndex].index = newIndex;
      this.NormalizeIndexes();
    }
  }

  NormalizeIndexes() {
    // Sort all widgets first by context key then index
    this.widgetRegistrationCopy.groupedWidgets =
      this.widgetRegistrationCopy.groupedWidgets.sort((a, b) => {
        const first = a.contextKey.localeCompare(b.contextKey);
        return first === 0 ? a.index - b.index : first;
      });

    // Reset index value
    this.widgetRegistrationCopy.groupedWidgets.forEach((gw, i) => {
      if (i > 0) {
        if (this.widgetRegistrationCopy.groupedWidgets[i - 1].contextKey !== gw.contextKey) {
          gw.index = 1;
        } else {
          gw.index = this.widgetRegistrationCopy.groupedWidgets[i - 1].index + 1;
        }
      }

      // sort this groups widgets and reset index value
      gw.widgets = gw.widgets.sort((a, b) => { return a.index - b.index; });
      gw.widgets.forEach((name, widgetIdx) => { name.index = widgetIdx + 1; });
    });
  }

  UnavailableWidgets(): WidgetConfiguration[] {

    const hiddenGroup = this.ContextMatchedGroups().find( g => g.hidden);
    if (hiddenGroup) {
      hiddenGroup.widgets = hiddenGroup.widgets.filter( wc => this.matchingWidgets.findIndex(m => m.name === wc.name) > -1);
      return this.matchingWidgets.filter(wc => hiddenGroup.widgets.findIndex(h => h.name === wc.name) > -1);
    } else {
      return [];
    }
  }

  AvailableWidgets(): WidgetConfiguration[] {
    if (this.matchingWidgets === undefined) {
      return [];
    }

    const unavailable = this.UnavailableWidgets().map(wc => wc.name);
    if (this.widgetRegistrationCopy && this.widgetRegistrationCopy.groupedWidgets) {
      this.widgetRegistrationCopy.groupedWidgets
        .filter( g => g.contextKey === this.contextKey)
        .forEach( g => {
          g.widgets.forEach( w => { unavailable.push(w.name); });
        });
    }

    return this.matchingWidgets.filter(wc => {
      return unavailable.indexOf(wc.name) === -1;
    });
  }

  AddToNewGroup(wConfig: WidgetConfiguration) {
    this._removeFromAllGroups(wConfig.name);

    // Find the first actual group with no current widgets
    const index = this.ContextMatchedGroups()
      .findIndex(gw => this.WidgetsFor(gw).length === 0 && !gw.hidden);

    if (index === -1) {
      this.NewGroup().widgets.push({ name: wConfig.name, index: 1 });
    } else {
      this.ContextMatchedGroups()[index].widgets.push({ name: wConfig.name, index: 1 });
    }

  }

  AddToGroup(wConfig: WidgetConfiguration, widgetGroup: WidgetGroup) {
    this._removeFromAllGroups(wConfig.name);
    const index = widgetGroup.widgets.findIndex(x => x.name === wConfig.name);
    if (index === -1) {
      const nextIndex = widgetGroup.widgets.reduce<number>((p, c) => { return c.index >= p ? c.index + 1 : p; }, 1);
      widgetGroup.widgets.push({ name: wConfig.name, index: nextIndex });
    }
  }

  AddToUngrouped(wConfig: WidgetConfiguration) {
    this._removeFromAllGroups(wConfig.name);
    this.AddToMatching(wConfig);
  }

  AddToHidden(wConfig: WidgetConfiguration) {
    let hiddenGroup = this.ContextMatchedGroups().find( g => g.hidden);
    if (!hiddenGroup) {
      hiddenGroup = this.NewGroup(true);
    }
    this.AddToGroup(wConfig, hiddenGroup);
  }

  ClearGroup(widgetGroup: WidgetGroup) {
    const inScopeWidgets = this.WidgetsFor(widgetGroup);
    inScopeWidgets.forEach(w => { this._removeFromGroup(w, widgetGroup); });
  }

  private _removeFromAllGroups(widgetName: string) {
    this.ContextMatchedGroups().forEach((gw, i) => { this._removeFromGroup(widgetName, gw); });
  }

  private _removeFromGroup(widgetName: string, widgetGroup: WidgetGroup) {
    const idx = widgetGroup.widgets.findIndex(x => x.name === widgetName);
    if (idx > -1) {
      widgetGroup.widgets.splice(idx, 1);
    }
  }

  NewGroup(setHidden = false): WidgetGroup {
    const nextGroupIndex =
      this.ContextMatchedGroups().reduce<number>((p, c) => { return c.index >= p ? c.index + 1 : p; }, 1);
    const ret: WidgetGroup = {
      index: nextGroupIndex, widgets: [], widthSpec: '*', heightSpec: '*', contextKey: this.contextKey, hidden: setHidden
    };
    this.widgetRegistrationCopy.groupedWidgets.push(ret);
    return ret;
  }

  AddToMatching(wConfig: WidgetConfiguration) {
    const idx = this.matchingWidgets.findIndex(x => x.name === wConfig.name);
    if (idx === -1) {
      this.matchingWidgets.push(wConfig);
    }
  }

  ngOnInit() {
    this.Reset();
  }

  WidgetIsGrouped(widgetName: string) {

    for (let i = 0; i < this.ContextMatchedGroups().length; i++) {
      if (this.WidgetIsInGroup(widgetName, this.ContextMatchedGroups()[i])) {
        return true;
      }
    }
    return false;
  }

  WidgetIsInGroup(widgetName: string, widgetGroup: WidgetGroup) {
    return widgetGroup.widgets.findIndex(x => x.name === widgetName) > -1;
  }

  WidgetNameIndexesFor(widgetGroup: WidgetGroup): NameIndex[] {
    return widgetGroup.widgets
      .filter(w => this.matchingWidgets.findIndex(rw => rw.name === w.name) > -1)
      .sort((a, b) => { return a.index - b.index; });
  }

  WidgetsFor(widgetGroup: WidgetGroup): string[] {
    return this.WidgetNameIndexesFor(widgetGroup).map(x => x.name);
  }


  UsePreferred() {

    const preferred = this.displayStateService.GetPreferredSettings(this.contextKey);
    this.preferredSettingsCount = preferred.length;
    if (preferred && preferred.length > 0) {
      this.widgetRegistrationCopy.groupedWidgets =
        this.widgetRegistrationCopy.groupedWidgets.filter (g => {
            return g.contextKey !== this.contextKey;
          });

      preferred
        .forEach( pg => {
          this.widgetRegistrationCopy.groupedWidgets.push(pg);
        });
    }
  }

  SavePreferred() {
      this.displayStateService.SetPreferredSettings(this.contextKey, this.widgetRegistrationCopy.groupedWidgets);
      this.preferredSettingsCount = this.displayStateService.GetPreferredSettings(this.contextKey).length;
  }

  Save() {
    this.displayStateService.appState.current.userStatistics.widgetRegistration = this.widgetRegistrationCopy;

    this.displayStateService.appState.current.userStatistics.widgetRegistration.groupedWidgets =
      this.displayStateService.appState.current.userStatistics.widgetRegistration.groupedWidgets
        .filter(gw => gw.widgets.length > 0);
    this.displayStateService.SaveUserStats();

  }
}
